import { Box, CircularProgress } from '@mui/material';

const SPINNER_SIZE = 40;

const ReportRefreshOverlay = ({ open }) => {
  if (!open) {
    return null;
  }
  return (
    <>
      <Box
        aria-hidden
        data-testid="report-refresh-dim"
        sx={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.92)',
          zIndex: (theme) => theme.zIndex.modal
        }}
      />
      <Box
        role="status"
        aria-live="polite"
        aria-busy="true"
        aria-label="Loading report"
        data-testid="report-refresh-spinner"
        style={{ top: '50%', left: '50%' }}
        sx={{
          position: 'fixed',
          transform: 'translate(-50%, -50%)',
          zIndex: (theme) => theme.zIndex.modal + 1,
          pointerEvents: 'none'
        }}
      >
        <CircularProgress size={SPINNER_SIZE} />
      </Box>
    </>
  );
};

export default ReportRefreshOverlay;
